<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter justify-center items-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 m-4">
      <vx-card>

        <div v-if="currentConfig && currentConfig.logo" class="vx-card__title mb-6">
          <div style="text-align: center;"><img :src="currentConfig.logo" style="max-width: 300px; margin: auto;"></div>
          <br>
        </div>

        <div v-if="currentConfig === null">
          <vs-alert>Oops. Une erreur est survenue, SVP veuillez communiquer directement avec nous.</vs-alert>
        </div>
        <div v-else>

          <div v-if="!submitSuccess" class="subscription">
            <h4 class="text-center">
              Oups! Nous vous avons peut-être communiqué trop de courriels</h4>
            <br>
            <p>Nous en sommes sincèrement désolés. Nous vous invitons à choisir parmi les options suivantes</p>
            <vs-divider position="center"></vs-divider>

            <p v-for="question in currentConfig.questions ">
              <vs-radio v-model="selectedOption" :vs-value="question.action">{{ question.label }}</vs-radio>
            </p>


            <p><b>OU</b></p>

            <p>
              <vs-radio v-model="selectedOption" vs-value="stop">Ne plus jamais recevoir de courriels de votre part</vs-radio>
            </p>

            <div v-if="feedback_question">
              <vs-divider position="center"></vs-divider>

              {{ feedback_question }}
              <vs-textarea v-model="user_feedback"></vs-textarea>

            </div>

            <vs-divider position="center"></vs-divider>


            <vs-input v-model="email" v-validate="'email'" class="w-full mb-4"
                      label="Must be a valid email" label-placeholder="Email" name="email" type="email"/>

            <span v-show="errors.has('email')" class="text-danger text-sm">{{ errors.first('email') }}</span>


            <vs-divider position="center"></vs-divider>


            <vs-button :disabled="email.length === 0 ||selectedOption === '' || errors.has('email')" class="w-full" @click.prevent="submitForm">Confirmer</vs-button>

          </div>
        </div>

        <vs-alert :active.sync="submitSuccess" color="success">
          Merci, vos préférences ont été mises à jour.
        </vs-alert>
      </vx-card>
    </div>
  </div>
</template>


<script>
import { Base64 } from 'js-base64'
import axios from 'axios'
import moment from 'moment'
//
// Oups! Nous vous avons peut-être communiqué trop de courriels; nous en sommes sincèrement désolés. Nous vous invitons à choisir parmi ces 6 options:
//
//   Ne pas me contacter avant 2021
// Contact me in English Only
// M'informer uniquement sur les formations en ligne offertes
// Mes coordonnées ont changé
// M'informer à une fréquence maximale de 6 courriels par année
// OU
// Ne plus jamais recevoir de courriels de votre part
// Adresse courriel:
//
//
//
//   Oops, we might have sent you too much e-mail; we apologize. We invite you to choose between the following options:
//
//   Let me know only in 2021
// Contact me in English Only
// Let me know only about online workshops available
// My contact details have changed
// OR
// I do not wish to receive information anymore
export default {

  data () {

    const nextTimeOptionLabel = () => { // duplicate with english
      const year  = moment().year()
      const month = moment().month() + 1
      let label   = 'Ne pas me contacter avant '

      if (month < 6 || month === 12) {
        label += 'l\'automne '
      }

      return label + (year + (month === 12 ? 1 : 0))
    }

    const defaultQuestions = [
      {
        label:             nextTimeOptionLabel(),
        action:            'next_season',
        feedback_question: ''
      },
      {
        label:             'Mes coordonnées ont changé',
        action:            'contact_detail_changed',
        feedback_question: 'Veuillez indiquez vos nouvelles coordonnées (courriel, téléphone ou adresse) nous allons les mettre a jour et vous recontacter très bientôt.'
      },
      {
        label:             'M\'informer à une fréquence maximale de 6 courriels par année',
        action:            '6_per_year',
        feedback_question: null
      }
    ]

    return {
      config: {

        'communications.newera.systems':          {
          name:      'newera.systems',
          logo:      '/clients/logos/newera.png',
          questions: defaultQuestions
        },
        'communications.lepresent.com':           {
          name:      'lepresent.com',
          logo:      '/clients/logos/lepresent.png',
          questions: defaultQuestions
        },
        'communications.grouperp.ca':             {
          name:      'grouperp.ca',
          logo:      '/clients/logos/grouperp.png',
          questions: defaultQuestions
        },
        'communications.constructeurvirtuel.com': {
          name:      'constructeurvirtuel.com',
          logo:      '/clients/logos/constructeurvirtuel.png',
          questions: defaultQuestions
        },
        'communications.oncode.ca':               {
          name:      'oncode.ca',
          logo:      '/clients/logos/oncode.png',
          questions: defaultQuestions
        }
      },

      currentConfig:     null,
      feedback_question: null,
      currentHost:       '',
      submitSuccess:     false,
      email:             '',
      user_feedback:     '',
      selectedOption:    '',
      communication_id:  null,
    }
  },

  components: {},
  mounted () {
    if (this.$route.query._neSessId) {
      this.email = Base64.decode(this.$route.query._neSessId)
    }

    if (this.$route.query._neCommId) {
      this.communication_id = this.$route.query._neCommId
    }

    this.currentHost = location.host


    if (this.currentHost.startsWith('192.168.1.')) {
      this.currentHost = 'communications.newera.systems'
    }

    this.currentConfig = this.config[this.currentHost]
  },
  methods: {

    async save () {

      axios.post('https://us-central1-newera-subscription-manager.cloudfunctions.net/updateSubscription', {
        origin: {
          organization: this.currentConfig.name,
          app: 'subscription-manager',
          version: '1.0'
        },
        action:       this.selectedOption,
        info:         {
          language:         'fr',
          email:            this.email,
          user_feedback:    this.user_feedback,
          communication_id: this.communication_id
        }
      })
        .then(() => {
          this.submitSuccess = true
        })
        .catch(function (error) {
          alert(error)
        })

    },
    submitForm () {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.save()
        } else {
          // form have errors
        }
      })
    }

  },
  watch:   {
    selectedOption () {
      this.feedback_question = null
      if (this.selectedOption === 'stop') {
        this.feedback_question = 'Si vous voulez, vous pouvez partager avec nous votre expérience et nous aider à nous améliorer.'
      } else {
        this.currentConfig.questions.forEach(q => {
          if (q.action === this.selectedOption && q.feedback_question) {
            this.feedback_question = q.feedback_question
          }
        })
      }
    }
  } // watch
}

</script>

